import * as React from "react"
import Layout from "../components/Layout/Layout"
import ProjectPageLayout from "../components/ProjectPageLayout/ProjectPageLayout"
import Seo from "../components/Seo/Seo"
import ProjectGroup from "../components/ProjectGroup/ProjectGroup"

const DesktopProjects = () => (
  <Layout>
    <ProjectPageLayout
      heading="Desktop Applications"
    >
      <Seo title="Desktop Projects" />
      <ProjectGroup projectType="desktop"/>
    </ProjectPageLayout>
  </Layout>
)

export default DesktopProjects
